import { gql } from '@lcs/shared/api';

export const deleteLocationMutation = gql`
   mutation DeleteLocation($locationId: UInt!) {
      deleteLocation(id: $locationId)
   }
`;
